import styled from 'styled-components'
import { COLORS } from 'utils'

export interface SwitchStyles {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  cursor?: string
}

export const SwitchCustom = styled.div<SwitchStyles>`
  && {
    margin-top: ${({ marginTop }) => marginTop || '0'};
    margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
    margin-left: ${({ marginLeft }) => marginLeft || '0'};
    margin-right: ${({ marginRight }) => marginRight || '0'};
    cursor: ${({ cursor }) => cursor};
  }
  background: transparent;
`
interface ISwitchProps {
  state: boolean
}
export const SwitchStack = styled.div<ISwitchProps>`
  width: 2.5625rem;
  height: 1.3751rem;
  display: flex;
  align-items: center;
  justify-content: ${({ state }) => (state ? 'flex-end' : 'flex-start')};
  background: ${({ state }) => (state ? COLORS.primary : COLORS.lightGray)};
  padding: 0.1rem 0.2rem;
  border-radius: 4rem;
`

export const SwitchIcon = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: ${COLORS.white};
`
